import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ToastWrapper } from '@/components/Message';
import * as service from '@/api/service';
import store from '@/store';
import Loading from '@/components/Loading';
import common from '@/utils/common';
import ErrorBoundary, { TopError } from '@/components/ErrorBundary';
import { ClassType, RoleType } from '@/utils/interface';
import Routers from './router';
import intl from 'react-intl-universal';
import { Toast } from '@/components/Message';
import PlaybackDialog from "@/components/PlaybackDialog";
import NoticeDialog from "@/components/NoticeDialog";
import { checkDomain } from '@/utils/utils';
// import NotSupport from './components/NotSupport';

const { REACT_APP_APIURL, REACT_APP_APIURL_BACKUP } = process.env;

const App = (props: any) => {
  const { token, searchParams } = props;
  // orgId: 需要切换登录时必传
  // cid: 传教室id，使用其他参数名会使init请求数据失败
  let { cid: classroomId, shareCode, unid, fromSource, orgId } = searchParams;  // unid fromSource token
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState();
  const [agreeChecked, setAgreeChecked] = useState<boolean>(false);
  const [watchVideoNoticeDialog, setWatchVideoNoticeDialog] = useState<boolean>(false);
  const [showNoticeDialog, setShowNoticeDialog] = useState<boolean>(false);
  const [isAgree, setIsAgree] = useState<boolean>(false);
  const [isSupport, setIsSupport] = useState(true);  // false: 不支持该浏览器  true: 支持该浏览器
  const APP_APIURL = async() =>  await checkDomain(REACT_APP_APIURL) ? REACT_APP_APIURL : REACT_APP_APIURL_BACKUP
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        // 知识点分享
        if (shareCode) {
          // 若没有登录会抛错，走到catch兜底登录
          const shareData: any = await service.getShareInfo({ shareCode });
          if (shareData) {
            ({ classroomId } = shareData);
            const recordDetail = await service.getRecordDetail({ classroomId });
            store.dispatch({
              type: 'SET_BUSINESS_INFO',
              payload: {
                businessInfo: {
                  type: 'share', // 知识点分享
                  data: {
                    ...shareData,
                    playerUrl: shareData.videoUrl,
                    classroomName: shareData.name || '',
                    ...recordDetail || {},
                  }
                }
              },
            });
          }
          await fetchAndSetUserInfo();
          process.env.ORG !== 'meike' && token && await getBoardsData();
          document.title = shareData.name || (process.env.ORG == 'meike' ? intl.get('VODPLAYER_MEIKE_TITLE') : intl.get('VODPLAYER_ROOMBOX_TITLE'));
          setWxShare(shareData.name);
          setIsLoading(false);
          return;
        } else if (fromSource === 'yunpan') {
          const yunpanData: any = await service.yunpanPreview(unid, token);
          if (Array.isArray(yunpanData) && yunpanData.length > 0) {
            store.dispatch({
              type: 'SET_BUSINESS_INFO',
              payload: {
                businessInfo: {
                  type: 'yunpan',
                  data: {
                    ...yunpanData,
                    videoId: yunpanData[0]?.mediaId,
                    playerUrl: yunpanData[0]?.href,
                  }
                }
              }
            })
          }
          await fetchAndSetUserInfo();
          process.env.ORG !== 'meike' && token && await getBoardsData();
          setIsLoading(false);
          return;
        } else if (fromSource === 'highLight') {
          initHighLight();
          return;
        } else {
          const data: any = await service.getIsTour({ classroomId });
          const { videoShareType, videoUrl, name, roleId, isMakeUp } = data || {};
          // 游客且没有登录 URL从tour接口取
          if (videoShareType === 2 && !token) {
            store.dispatch({
              type: 'SET_BUSINESS_INFO',
              payload: {
                businessInfo: {
                  type: 'tour', // 游客模式
                  data: {
                    ...data,
                    playerUrl: videoUrl[0], // 播放器url
                    classroomName: name, // 教室名称
                  }, // 拉平信息
                }
              },
            });
            setIsLoading(false);
            return;
          }
          if (!token) { common.login(); return; } 
          if (token) {
            if ((isMakeUp || orgId == 2000) && !common.isClient()) {
              setShowNoticeDialog(true);
            }
            if (isMakeUp && roleId === 3) {
              setWatchVideoNoticeDialog(true);
              return;
            }
          }
        }
        // 非游客 没有登录的跳登录(可删除)
        if (!token) { common.login(); return; }
        init();
      } catch (error: any) {
        setIsError(true);
        setError(error);
        setIsLoading(false);
        console.error('index_error', error);
        // 21012: 未登录 401: 登录过期-----统一处理登录错误跳转登录页面
        if ([21012, 401].includes(error?.code)) {
          localStorage.removeItem('vod_token');
          common.login();
        }
        return;
      }
    })()
  }, []);

  // 高光时刻
  const initHighLight = async () => {
    if (!token) { common.login(); return; }
    const res = await service.getHighLightVideo({ cid: classroomId })
    const videoId = res.mediaId;
    const videoStatus = res.inClassroom === 1 ? res.status === '' ? 3 : res.status : -1;
    // 用来处理高光时刻模式下的游客模式
    store.dispatch({
      type: 'SET_BUSINESS_INFO',
      payload: {
        businessInfo: {
          type: 'highLight',
          data: {
            videoId: videoId,
            videoStatus: videoStatus,
          }
        }
      }
    })
    if (res.inClassroom === 1 && res.status === 1 && res.mediaId) {
      process.env.ORG !== 'meike' && token && await getBoardsData();
      const [data, recordDetail, _] = await Promise.all([
        service.getClassroom({ classroomId, module: 'playback' }),
        service.getRecordDetail({ classroomId }),
        fetchAndSetUserInfo()
      ]);
      const { playback } = data || {};
      const {
        templateId, // 班型， 1小班 2分组班 3精品班 4VIP 5超大班 100录播课
        recordedMedia,
        name,
      } = playback || {};
      store.dispatch({
        type: 'SET_CLASS_INFO',
        payload: {
          classInfo: {
            type: 'highLight', // 回放
            data: {
              ...playback,
              videoId: videoId,
              videoStatus: videoStatus,
              classroomName: name,
              ...recordDetail || {},
            },
          }
        },
      });
    }
    setIsLoading(false);
  }

  // 兼容补课-抽离出主逻辑
  const init = async () => {
    // 以下是登录正常后的主逻辑
    // 获取灵动版位点播系统信息
    if (process.env.ORG !== 'meike') {
      await getBoardsData();
    }
    // 获取回放、录播的教室信息、刷新token并获取用户信息
    const [data, recordDetail, _] = await Promise.all([
      service.getClassroom({ classroomId, module: 'playback' }),
      service.getRecordDetail({ classroomId }),
      fetchAndSetUserInfo()
    ]);
    const { playback } = data || {};
    const {
      templateId, // 班型， 1小班 2分组班 3精品班 4VIP 5超大班 100录播课
      recordedMedia,
      name,
    } = playback || {};
    // 录播课
    if (templateId === ClassType.RECORD_CLASS) {
      store.dispatch({
        type: 'SET_CLASS_INFO',
        payload: {
          classInfo: {
            type: 'record', // 录播课
            data: {
              ...playback,
              ...recordedMedia, // 平铺录播课信息
              playerUrl: recordedMedia.url,
              videoId: playback.mediaIds[0],
              classroomName: name,
              ...recordDetail || {},
            },
          }
        },
      });
    } else {
      store.dispatch({
        type: 'SET_CLASS_INFO',
        payload: {
          classInfo: {
            type: 'playback', // 回放
            data: {
              ...playback,
              playerUrl: playback.videoUrl[0],
              videoId: playback.mediaIds[0],
              classroomName: name,
              ...recordDetail || {},
            },
          }
        },
      });
    }
    console.log('searchParams.role', searchParams.role, +playback.roleId);
    const replayInfo = await service.getReplayInfo({ classroomId });
    store.dispatch({
      type: 'SET_REPLAY_INFO',
      payload: {
        replayInfo: replayInfo,
      },
    });
    const className = playback.name || '';
    document.title = className || (process.env.ORG == 'meike' ? intl.get('VODPLAYER_MEIKE_TITLE') : intl.get('VODPLAYER_ROOMBOX_TITLE'));
    setWxShare(className);
    setIsLoading(false);
  };

  // 获取灵动板位信息
  const getBoardsData = async() => {
    try {
      const boardsData = await service.getBoardsinfo({ boardKeys: ['Vod'] });
      let boardsDataValue: any = {};
      const { boards } = JSON.parse(boardsData);
      if (Array.isArray(boards) && boards.length > 0 && boards[0].value) {
        boardsDataValue = JSON.parse(boards[0].value);
      }
      const { appId = '', appSecret = '', domain = '', domain_list } = boardsDataValue;
      store.dispatch({
        type: 'SET_VIDEO_INFO',
        payload: {
          videoInfo: {
            appId,
            appSecret,
            domain,
            domainList: domain_list
          },
        },
      });
    } catch (error) {
      console.log('getBoardsinfo', error);
    }
  };

  useEffect(() => {
    // 在移动端 暂时只支持微信 钉钉
    if (common.isMobile() && !common.isWx() && !common.isDingTalk() && !common.isClient()) {
      Toast.tip(intl.get('NOT_SUPPORT_TIP'), true, { autoClose: true });
    }
  }, [])

  // 需要确认该域名是否在微信分享中注册
  const setWxShare = async(className: string) => {
    const win: any = window;
    if (/MicroMessenger/.test(navigator.userAgent)) {
      const script = document.createElement('script');
      script.src = '//res.wx.qq.com/open/js/jweixin-1.4.0.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      const apiUrl = await APP_APIURL();
      script.onload = () => {
        const res = fetch(
          `${apiUrl
          }/api/token/tencent/wechat/jsapi-sign?url=${encodeURIComponent(win.location.href.split('#')[0])}`,
        );
        res.then((res) => {
          res.json().then((res) => {
            try {
              if (win.wx) {
                win.wx.ready(() => {
                  const title = className || '';
                  const desc = '';
                  // 从哪里出来的，就拼哪里的参数
                  const { origin, pathname, href } = win.location;
                  const imgUrl = `${origin}${pathname}res/logo192.png`;
                  const link = href.replace(/&token=[^&]+/g, ''); // 把所有token去掉，分享不带token
                  win.wx.updateAppMessageShareData({ title, desc, link, imgUrl, success() { } });
                  win.wx.updateTimelineShareData({ title, link, imgUrl, success() { } });
                });
                const debug = false;
                const { appId, timestamp, nonceStr, signature, } = res?.data || {};
                const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData'];
                win.wx.config({ debug, appId, timestamp, nonceStr, signature, jsApiList });
              }
            } catch (e) {
              console.log(e);
            }
          });
        });
      };
    }
  };

  const fetchAndSetUserInfo = async () => {
    const userInfo: any = await service.getEffectiveToken(token);
    if (userInfo) {
      store.dispatch({
        type: 'SET_TOKEN',
        payload: {
          token: userInfo.token,
        },
      });
      localStorage.setItem('vod_token', userInfo.token);
      store.dispatch({
        type: 'SET_USER_INFO',
        payload: {
          userInfo: userInfo,
        },
      });
    }
  };
  const okWatchCallback = () => {
    if (agreeChecked) {
      setWatchVideoNoticeDialog(false);
      init();
    } else {
      // Toast.tip(intl.get('HOME_AGREE_WATCH'), true, { autoClose: true });
      setIsAgree(true);
    }
  };
  // 观看回放须知-取消
  const onWatchCancelCallback = () => {
    if (common.isClient()) {
      service.closeWindow('CloseWindow', JSON.stringify({}))
    } else {
      common.logout();
    }
    setWatchVideoNoticeDialog(false);
  }
  const onCheckedAgree = () => {
    if (!agreeChecked) setIsAgree(false);
    setAgreeChecked(!agreeChecked);
  }
  // 跳转到下载
  const onGoToDownload = () => {
    window.location.href = 'https://roombox.xdf.cn/download';
  }
  const onCloseNoticeDialog = () => {
    setShowNoticeDialog(false);
  }

  return (
    <ErrorBoundary errorType="top">
      <div style={{ width: '100%', height: '100%', overflowX: 'hidden', overflowY: 'auto' }}>
        {/* TopError用来捕捉异步错误 */}
        {isError ? <TopError error={error} /> : isLoading ? <Loading /> : <Routers />}
        {/* <ToastWrapper /> */}
      </div>
      {/* 观看视频须知 */}
      <PlaybackDialog
        show={watchVideoNoticeDialog}
        setShow={setWatchVideoNoticeDialog}
        conf={{
          title: intl.get('HOME_VIDEO_WATCH_NOTICE'),
          btns: [
            { id: 'cancel', text: intl.get('HOME_CANCEL'), callback: () => onWatchCancelCallback() },
            { id: 'submit', text: intl.get('HOME_CONFIRM_VIEW'), callback: () => okWatchCallback() },
          ]
        }}>
        <div className='watch-video-content'>{intl.get('HOME_VIDEO_REPETE')}，<span>{intl.get('HOME_AFTER_WATCH')}，</span>{intl.get('HOME_QUESTION_TIPS')}</div>
        <div className='watch-video-agree' onClick={() => onCheckedAgree()}>
          {isAgree && <div className='checked-tips'>{intl.get('HOME_VIDEO_PLEASE_CHECK')}</div>}
          <i className={`checked-default ${agreeChecked ? 'checked-active' : ''}`}></i>
          {intl.get('HOME_VIDEO_AGREE')}
        </div>
      </PlaybackDialog>
      <NoticeDialog
        show={showNoticeDialog}
        conf={{
          btns: [
            { id: 'submit', text: intl.get('HOME_DOWNLOAD_APP'), callback: () => onGoToDownload() },
            { id: 'cancel', text: '', callback: () => onCloseNoticeDialog() },
          ]
        }}>
        <div className='download-roombox-logo'></div>
      </NoticeDialog>
      
    </ErrorBoundary>
  )
};

const mapStateToProps = (state: { common: any; token: any; }) => ({
  ...state.common,
});

export default connect(
  mapStateToProps,
)(App);
